export enum FormFieldImages {
  SingleFormField = 'single_text_field',
  SingleDropdown = 'single_dropdown_field',
  SingleTextArea = 'single_text_area_field',
}